const clone = require('lodash/clone');

const env = require('../helpers/env.js');
const filterIceServers = require('./filterIceServers.js');
const shouldUsePlanBSDP = require('../helpers/shouldUsePlanBSDP.js');
const logging = require('./log')('createPeerConnection');

module.exports = function createPeerConnection({
  window,
  config: originalConfig,
  constraints,
}) {
  logging.debug('called');

  const config = clone(originalConfig);

  config.iceServers = filterIceServers(env, config.iceServers);
  if (shouldUsePlanBSDP()) {
    config.sdpSemantics = 'plan-b';
  }
  const pc = new window.RTCPeerConnection(config, constraints);

  return Promise.resolve(pc);
};
